// Date-range preset menu items shown in the date picker and as the
// segmented control in ActivityChart. Pure UI labels — the actual
// date math (translating "1M" → from/to bounds) lives in shell.js.
export const DATE_RANGE_PRESETS = [
  { id: "1D", label: "1D", summary: "Intraday usage" },
  { id: "5D", label: "5D", summary: "Rolling week" },
  { id: "1M", label: "1M", summary: "Current operating month" },
  { id: "1Q", label: "1Q", summary: "Last 90 days" },
];
